/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import React from "react";
import AllReports from "../../../MiddleMileOperations/ExceptionReports/allReports";

const DirectorDashboard = () => {
    const embeddedId = "6d8d98bd-1db2-4323-adaf-313ac0a9b5c5";
    const rsl = [];
    const title = "Director Dashboard";
    
    return (
        <div>
            <AllReports embeddedId={embeddedId} rsl={rsl} title={title} />
        </div>
    );
};

export default DirectorDashboard;

